<template>
  <b-card no-body class="p-2">
    <div class="d-sm-flex justify-content-between align-items-center mb-3">
      <h4 class="card-title mb-50 mb-sm-0">گزارش فروش</h4>
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center mr-2">
          <span
            class="bullet bullet-primary svg-font-small-3 mr-50 cursor-pointer"
          />
          <span>فروش </span>
        </div>
        <div class="d-flex align-items-center ml-75">
          <span
            class="bullet bullet-warning svg-font-small-3 mr-50 cursor-pointer"
          />
          <span>جریمه های پرداخت شده</span>
        </div>
        <div class="d-flex align-items-center ml-75">
          <span
            class="bullet bullet-info svg-font-small-3 mr-50 cursor-pointer"
          />
          <span>جریمه های پرداخت نشده</span>
        </div>
      </div>
    </div>
    <div v-if="loading" class="mt-2">
      <b-skeleton width="100%" height="200px"></b-skeleton>
    </div>
    <!-- chart -->
    <b-card-body v-else class="d-flex justify-content-center w-100 p-0">
      <vue-apex-charts
        style="overflow-x: auto; overflow-y: hidden"
        id="revenue-report-chart"
        type="bar"
        height="230"
        width="950"
        :options="revenueReport.chartOptions"
        :series="series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BSkeleton, BCardBody } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";

export default {
  components: {
    VueApexCharts,
    BCard,
    BSkeleton,
    BCardBody,
  },

  data() {
    return {
      loading: false,
      statistics: [],
      series: [
        {
          name: "فروش",
          data: [],
        },
        {
          name: "جریمه های پرداخت شده",
          data: [],
        },
        {
          name: "جریمه های پرداخت نشده",
          data: [],
        },
      ],
      revenueReport: {
        chartOptions: {
          chart: {
            stacked: false,
            type: "bar",
            toolbar: { show: false },
          },
          grid: {
            padding: {
              top: -20,
              bottom: -10,
              left: -30,
            },
            yaxis: {
              lines: { show: true },
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: "#6E6B7B",
                fontSize: "0.86rem",
                fontFamily: "Montserrat",
              },
            },
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          colors: [
            $themeColors.primary,
            $themeColors.warning,
            $themeColors.info,
          ],
          plotOptions: {
            bar: {
              columnWidth: "17%",
              borderRadius: 3,
            },
            distributed: true,
          },
          yaxis: {
            labels: {
              offsetX: -50,
              style: {
                colors: "#6E6B7B",
                fontSize: "0.86rem",
                fontFamily: "Montserrat",
              },
            },
          },
        },
      },
      // budget chart
      budgetChart: {
        options: {
          chart: {
            height: 80,
            toolbar: { show: false },
            zoom: { enabled: false },
            type: "line",
            sparkline: { enabled: true },
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 5],
            width: [2],
          },
          colors: [$themeColors.primary, "#dcdae3"],
          tooltip: {
            enabled: false,
          },
        },
      },
    };
  },
  created() {
    this.getEarning();
  },
  methods: {
    async getEarning() {
      this.loading = true;
      try {
        const { data } = await this.$http.get("panel/semesters/earning");
        this.statistics = data.data[0];
        this.revenueReport.chartOptions.xaxis.categories = this.statistics.map(
          (x) => x.semester.name
        );
        this.series[0].data = this.statistics.map((x) => x.earning);
        this.series[1].data = this.statistics.map((x) => x.penalty.payed);
        this.series[2].data = this.statistics.map((x) => x.penalty.not_payed);
      } catch (e) {}
      this.loading = false;
    },
  },
};
</script>
